
export default {
    getFormacao(state) {
        return state.formacao;
    },
    getFormacoes(state) {
        return state.formacoes;
    },
}